// Generated by Melange

import * as Fx from "../../fx/fx.jsx";
import * as Stdlib__Int from "melange/int.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Subsonic__TopSongs from "./topSongs.jsx";
import * as Subsonic__Utils from "./utils.jsx";

function make(artistName, count, param) {
  const params = {};
  return Fx.Monad_syntax.let$star((params["artist"] = {
    TAG: /* Value */ 1,
    _0: artistName
  }, Stdlib__Option.iter((function (count) {
    params["count"] = {
      TAG: /* Value */ 1,
      _0: Stdlib__Int.to_string(count)
    };
  }), count), Subsonic__Utils.makeRequest({
    _method: "rest/getTopSongs",
    params: params
  }, Subsonic__TopSongs.of_json)), (function (param) {
    return {
      TAG: /* Ok */ 0,
      _0: param.response.topSongs.song
    };
  }));
}

export {
  make,
}
/* No side effect */
